// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"Bo-z","breadcrumbForward":"Co-z","breadcrumbBack":"Do-z","selected":"Eo-z"};